import gql from 'graphql-tag';

const GET_CLOSED_REPORTS = gql`
  query closedReports($closedFrom: Date!, $closedTo: Date!) {
    closedReports(closedFrom: $closedFrom, closedTo: $closedTo) {
      report {
        id
        label
        creator {
          name
        }
        createdAt
      }
      locationNumber
    }
  }
`;

export default GET_CLOSED_REPORTS;
